import { Icon } from '@iconify/react';
import { Box, IconButton, Stack, Typography } from '@mui/material';

export default function DeepSearchBanner({
  isPanelOpen,
  onTogglePanel,
  selectedIds = [],
  getTranscriptName,
  onRemoveTranscript,
  onOpenSelection,
}) {
  return (
    <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 99 }}>
      {isPanelOpen && (
        <Box display="flex" justifyContent="space-between" sx={{ bgcolor: '#f5e8f9', px: 2 }}>
          <Box py={1}>
            {selectedIds?.length ? (
              <Typography fontWeight="bold">Selected Transcripts</Typography>
            ) : (
              <>
                <Typography fontWeight={600}>No transcript selected</Typography>
                <Typography>
                  {`You haven't selected any specific transcript, so the system will use the entire transcript for this conversation.`}
                </Typography>
              </>
            )}
            <Box display="flex" gap={2} flexWrap="wrap" mt={0.8}>
              {selectedIds?.map((tid) => (
                <Stack
                  key={tid}
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ backgroundColor: '#cfdeea', borderRadius: 4, px: 1, py: 0.3 }}
                >
                  <Typography variant="body2" lineHeight={1}>
                    {getTranscriptName ? getTranscriptName(tid) : `Transcript ${tid}`}
                  </Typography>
                  <Icon
                    icon="bitcoin-icons:cross-filled"
                    width={20}
                    height={20}
                    style={{ cursor: 'pointer' }}
                    onClick={() => onRemoveTranscript && onRemoveTranscript(tid)}
                  />
                </Stack>
              ))}
            </Box>
          </Box>
          <Box
            sx={{
              width: 60,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: '#cfdeea',
              my: 1,
              mr: 2,
            }}
          >
            <Icon
              icon="mage:filter"
              width={24}
              height={24}
              color="#7d5ae8"
              style={{ cursor: 'pointer' }}
              onClick={() => onOpenSelection && onOpenSelection()}
            />
          </Box>
        </Box>
      )}
      <Box display="flex" justifyContent="flex-end" px={2} mt={0.3} mr={3.4}>
        <IconButton onClick={() => onTogglePanel && onTogglePanel()} sx={{ bgcolor: '#cfdeea' }}>
          <Icon icon={isPanelOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'} width={24} />
        </IconButton>
      </Box>
    </Box>
  );
}
